import { Link } from "react-router-dom";
import blogData from "../../Database/blog_business_posts.json";
import MetaTags from "../../../components/MetaTags";
export default function BlogHome() {
    const BlogDataArray = blogData.BlogBusinessData
    const moment = require('moment');
    return(
        <>
        <MetaTags 
            title="Blog"
            description="Here is my blog, where I share my ideas described on posts I have done regarding Data Science, Machine Learning and AI impacting the business"
             />
        <div className="pt-1 pb-5" id="wd-blog-home">
            <div>
            <h1 id="wd-blog-title">Blog</h1>
            </div> 
            <hr/>
            <h2 id="wd-blog-published"> Posts New ({BlogDataArray.length})</h2>
            
            <div id="wd-blog-posts" className="row ms-4">
                <div className="row justify-content-center row-cols-1 row-cols-md-5 row-cols-g-4 gy-3">

                {BlogDataArray.map((blog) => ( 
                
                <div className="wd-blog-post col" style={{width: "300px"}}>
                <Link to={`/blog/${blog._id}/Home`} className="text-decoration-none">
                    <div className="card rounded-3 overflow-hidden h-100">
                    <img className="card-img-top img-fluid" 
                            src={blog._principal_img} width={"160"}/>
                    <div className="card-body d-flex flex-column">
                        <span className="wd-blog-post-link text-center"
                            style={{ textDecoration:"none", color:"navy", fontWeight:"bold"}}>
                         {blog._title} </span>
                        <div><p className="wd-blog-post-title card-text" style={{maxHeight:45, overflow:"hidden"}}>
                        {blog._small_description} </p>       </div>  
                        <div className="mt-auto"><p className="wd-blog-post-title card-text"><small className="text-muted">Last updated {moment(blog._date).format('MM/DD/YYYY')}</small></p></div>
                        <div className="btn-go mt-auto">
                        <Link to={`/blog/${blog._id}/Home`} className="btn btn-primary">Go</Link>
                        </div>
                    </div>
                    </div>
                </Link>
                </div> 
                ))}
                
                </div>
            </div>
        </div>
    </>

    );

}